<template>
  <div>
    <card-collapse
      border-variant="primary"
      title-class="d-flex justify-content-between"
    >
      <template #card-title>
        <span style="width: 50%;">{{ document.name }}</span>
        <div style="width: 50%;" class="d-flex justify-content-between align-items-center">
          <div style="width: 50%; gap: 10px;" class="d-flex">
            <span>Status: </span>
            <div class="d-flex align-items-center" style="gap: 10px;">
              <b-badge
              :variant="resolveDocumentStatus(document)['variant']"
              >
              {{ resolveDocumentStatus(document)['text'] }}
              </b-badge>
              <b-badge
                v-if="document.status && document.status != 'PENDING'"
                :variant="resolveDocStatus(document.status)['variant']"
                >
                {{ document.status.toLowerCase()}}
              </b-badge>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center " style="width: 45%; gap:10px"
          v-if="document.status == 'PENDING'">
            <b-button :disabled="!document.documentUrl || loadingDocStatus"
            variant="outline-primary" size="sm" @click="handleDocStatus('VALID')">
            <b-spinner
                v-if="loadingDocStatus"
                small
              />
              <feather-icon v-else
                icon="CheckIcon"
                size="16"
              />
          </b-button>
            <b-button :disabled="!document.documentUrl || loadingDocStatus"
            variant="outline-danger" size="sm" @click="handleDocStatus('INVALID')">
            <b-spinner
                v-if="loadingDocStatus"
                small
              />
              <feather-icon v-else
                icon="XIcon"
                size="16"
              />
          </b-button>
        </div>
      </div>
      </template>

      <template>
        <div class="demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255,  255, 0.15)'"
            v-b-modal.update-document-modal
            :disabled="cardViewMode"
            variant="primary"
            @click="applyDocumentToChange(document)"
          >
            <feather-icon
              icon="EditIcon"
              class="mr-25"
            />
            <span>Upload</span>
          </b-button>

          <b-link
            v-if="document.documentUrl"
            :href="document.documentUrl"
            target="_blank"
          >
            <feather-icon
              icon="ExternalLinkIcon"
              class="mr-25"
            />
            <span>View</span>
          </b-link>
        </div>
      </template>
    </card-collapse>
  </div>
</template>

<script>
import {
  BLink, BBadge, BButton, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, inject } from '@vue/composition-api'
import useDocumentsList from '@/views/driver/documents/useDocumentsList'
import CardCollapse from '@/UI/CardCollapse.vue'

export default {
  components: {
    BButton,
    BBadge,
    BLink,
    CardCollapse,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    const collapseCard = ref(false)

    function applyDocumentToChange(document) {
      ctx.emit('apply-document-to-change', document)
    }
    const cardViewMode = inject('cardViewMode')

    return {
      cardViewMode,
      collapseCard,
      applyDocumentToChange,
      ...useDocumentsList(props, ctx),
    }
  },
}
</script>

<style>

</style>
